<div class="checktag" [class.active]="toggleChecktag()" (click)="toggleCheck()">{{ checktagTitle() }}</div>
